import { useSelector } from '@/lib/store'
import {
  calculateAge,
  deepClone,
  getNonCityProductUrl,
  getProductUrl,
  isEmpty,
  isNonCityRoute,
} from '@/utils/commonFunc'
import { consumerRequest } from './request'
import { REMOVE_DUPLICATE_PRODUCT_API } from './apiConstants'
import { DEFAULT_CITY_SLUG } from '@/utils/constants'
import { loadState } from '@/utils/localStorage'
import { usePathname } from 'next/navigation'

const PACKAGE_HELPER = () => {
  const cartState = useSelector((state) => state.cart) || {}
  const userState: any = useSelector((state) => state.user) || {}
  const USER_STATE = deepClone(userState)
  const cityState = useSelector((state) => state.city) || {}

  const pathname = usePathname()
  const cityFromUrl = pathname?.split('/')?.[2]

  delete USER_STATE?.membersList

  const ACTIVE_MEMBER: any =
    (cartState?.activePatientDetailDto !== null
      ? cartState?.activePatientDetailDto
      : cartState.activePatientDetailDto == null &&
        userState?.membersList?.length > 1
      ? {}
      : USER_STATE) || {}

  const handleCheckValidationForProduct = async (
    productDetails: any,
    selectedUser: any = {}
  ) => {
    const SELECTED_MEMBER =
      Object.keys(selectedUser || {}).length > 0 ? selectedUser : ACTIVE_MEMBER
    if (SELECTED_MEMBER === null || Object.keys(SELECTED_MEMBER || {}).length === 0)
      return { errorMessage: '', productId: '' }

    const CALCULATED_AGE = calculateAge(SELECTED_MEMBER?.dob)
    const { genderList, minAge, maxAge } = productDetails?.validationDto || {}
    const productId = productDetails?.productDto?.id
    // No gender list means no gender restriction. Previously `genderList?.includes()`
    // returned undefined here, which read as "invalid" and toasted
    // "can be added for undefined patient(s) only" - blocking a valid add to cart.
    const hasGenderRestriction = Array.isArray(genderList) && genderList.length > 0
    const isGenderValid =
      !hasGenderRestriction || genderList.includes(SELECTED_MEMBER?.gender)
    const isAgeValid = (minAge == null || minAge <= CALCULATED_AGE) && (maxAge == null || maxAge >= CALCULATED_AGE)

    if (!isGenderValid) {
      const validGenders = genderList.join(' and ')
      return {
        errorMessage: `This test can be added for ${validGenders} patient(s) only.`,
        productId: productId,
      }
    }

    if (!isAgeValid) {
      const ageMessage =
        CALCULATED_AGE < minAge
          ? `Available for patients aged ${minAge} and above.`
          : `Available for patients aged ${maxAge} and below.`

      return { errorMessage: ageMessage, productId: productId }
    }

    return { errorMessage: '', productId: '' }
  }

  const handleRemoveDuplicateProductFromCart = async (data: any) => {
  const loggedInMobileNumber = loadState('ctxVal') || null

  const formData = { ...data, bookingCreationNumber: loggedInMobileNumber }
    const apiResponse: any = await consumerRequest(
      REMOVE_DUPLICATE_PRODUCT_API,
      'post',
      formData
    )
    if (apiResponse?.status === true) {
      return apiResponse
    }
  }

  const getTestOrPackageUrl = (pDto: any, citySlug?: string) => {
    if (isNonCityRoute(pathname)) {
      return getNonCityProductUrl(pDto)
    }

    // The default city is the last resort: without it a store with no
    // currentCityObj produces a crawlable /{type}/undefined/{id}/{slug}.
    const slug = !isEmpty(citySlug)
      ? citySlug!
      : !isEmpty(cityFromUrl)
      ? cityFromUrl
      : cityState?.currentCityObj?.slugName || DEFAULT_CITY_SLUG

    return getProductUrl(pDto, slug)
  }

  return {
    getTestOrPackageUrl,
    handleCheckValidationForProduct,
    handleRemoveDuplicateProductFromCart,
  }
}

export default PACKAGE_HELPER
